import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
// import(`./assets/css/sass/themes/theme1.scss`)
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { IconContext } from "react-icons";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';



const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(

  <IconContext.Provider value={{ size: "24" }}>
    {/* <React.StrictMode> */}
    <App />
    <ToastContainer position="bottom-left" />
    {/* </React.StrictMode> */}
  </IconContext.Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

serviceWorkerRegistration.register({
  onUpdate: registration => {
    // اینجا پیام به کاربر نشون بده
    const confirmRefresh = window.confirm(
      "نسخه جدیدی از اپلیکیشن موجود است. آیا مایلید بروزرسانی انجام شود؟"
    );
    if (confirmRefresh) {
      // اپدیت service worker
      if (registration && registration.waiting) {
        registration.waiting.postMessage({ type: 'SKIP_WAITING' });
        registration.waiting.addEventListener('statechange', e => {
          if (e.target.state === 'activated') {
            window.location.reload();
          }
        });
      }
    }
  }
});
